import { Grid, Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import colors from 'styles/colors';
import Box from '@mui/material/Box';
import { useState } from 'react';

const SubmissionProblemInput = ({
  config, formik, handleSubmit, onBlur, maxSubmissions, submittedCount, descriptionConfig,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle form submission with prevention of double clicks
  const handleFormSubmit = async (fieldName, textareaName) => {
    if (isSubmitting) return; // Prevent double submission

    setIsSubmitting(true);
    try {
      await handleSubmit(fieldName, textareaName);
    } finally {
      // Use setTimeout to ensure the button stays disabled for a short period
      // This prevents accidental double clicks even if the submission is very fast
      setTimeout(() => {
        setIsSubmitting(false);
      }, 500);
    }
  };
  const {
    component: InputComponent,
    name,
    grid,
    ...props
  } = config;

  const {
    component: TextareaComponent,
    name: textareaName,
    grid: textareaGrid,
    inputType,
    ...textareaProps
  } = descriptionConfig;

  if (!InputComponent) {
    console.error('❌ InputComponent is undefined in SubmissionProblemInput. Check config.component.');
    return null; // Prevent crashing
  }

  return (
    <Grid
      item
      xs={grid}
      sx={{
        marginBottom: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        '.MuiTextField-root': {
          backgroundColor: 'transparent',
          background: 'transparent',
        },
      }}
    >
      <InputComponent
        {...props}
        label="Answer"
        type={inputType}
        sx={{
          width: '100%', height: '75px', minHeight: '75px', flex: '1',
        }}
        labelSx={{ paddingLeft: '12px' }}
        autoComplete="off"
        value={formik.values[name]}
        error={formik.touched[name] && !!formik.errors[name]}
        helperText={formik.touched[name] && formik.errors[name]}
        name={name}
        onChange={formik.handleChange}
        onBlur={() => onBlur(name)}
      />
      <TextareaComponent
        {...textareaProps}
        label="Please explain in a few words how you came up with this answer"
        sx={{
          width: '100%', flex: '1', marginTop: '8px', minHeight: '125px',
        }}
        labelSx={{ paddingLeft: '12px' }}
        autoComplete="off"
        multiline
        rows={3}
        value={formik.values[textareaName]}
        error={formik.touched[textareaName] && !!formik.errors[textareaName]}
        helperText={formik.touched[textareaName] && formik.errors[textareaName]}
        name={textareaName}
        onChange={formik.handleChange}
        onBlur={() => onBlur(textareaName)}
      />
      <Box sx={{
        height: '55px',
        display: 'flex',
        width: '100%',
        justifyContent: 'end',
      }}
      >
        <Typography
          variant="body1"
          sx={{
            height: '35px',
            lineHeight: '35px',
            color: colors.text.secondary,
            marginRight: '8px',
            verticalAlign: 'middle',
            fontSize: '12px',
          }}
        >
          {`(${maxSubmissions - submittedCount} tries left)`}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          disabled={isSubmitting
            || submittedCount >= maxSubmissions
            || (formik.touched[name] && !!formik.errors[name])
            || (formik.touched[textareaName] && !!formik.errors[textareaName])}
          onClick={() => handleFormSubmit(name, textareaName)}
          sx={{ height: '35px' }}
        >
          Submit
        </Button>
      </Box>
    </Grid>
  );
};

export default SubmissionProblemInput;
